import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Mission } from "@/components/sections/Mission";
import { Audience } from "@/components/sections/Audience";
import { Products } from "@/components/sections/Products";
import { Blends } from "@/components/sections/Blends";
import { Ritual } from "@/components/sections/Ritual";
import { Reviews } from "@/components/sections/Reviews";
import { Social } from "@/components/sections/Social";
import { FAQ } from "@/components/sections/FAQ";
import { Newsletter } from "@/components/sections/Newsletter";
import { Footer } from "@/components/sections/Footer";
import { StickyCartButton } from "@/components/StickyCartButton";
import { CartDrawer } from "@/components/CartDrawer";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Seo } from "@/components/Seo";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    { "@type": "Question", name: "Wat is blauwe lotus thee en wat doet het?", acceptedAnswer: { "@type": "Answer", text: "Blauwe lotus thee (Nymphaea caerulea) is een eeuwenoude kruidenthee uit Egypte met kalmerende, licht euforische effecten. Het bevordert ontspanning, levendige dromen en een gevoel van welzijn." } },
    { "@type": "Question", name: "Is blauwe lotus gevaarlijk of legaal in Nederland?", acceptedAnswer: { "@type": "Answer", text: "Blauwe lotus is 100% legaal in Nederland en de EU en bij normaal gebruik niet gevaarlijk. Het is niet verslavend. Gebruik het niet in combinatie met alcohol, slaapmiddelen of antidepressiva zonder overleg met je arts." } },
    { "@type": "Question", name: "Waar kan ik de beste blauwe lotus thee kopen?", acceptedAnswer: { "@type": "Answer", text: "Je koopt premium blauwe lotus thee, druppels en tinctuur direct bij Lunssence op lunssence.com. Wij leveren biologische, geteste Nymphaea caerulea met gratis verzending vanaf €50." } },
    { "@type": "Question", name: "Wat is het verschil met de blauwe lotus thee van Holland & Barrett?", acceptedAnswer: { "@type": "Answer", text: "Lunssence gebruikt enkel pure Egyptische Nymphaea caerulea bloemen zonder vulmiddelen, in hogere concentratie dan veel supermarkt- of drogisterijvarianten. Elke batch wordt getest op zuiverheid." } },
    { "@type": "Question", name: "Hoe bereid ik blauwe lotus thee?", acceptedAnswer: { "@type": "Answer", text: "Gebruik 1-2 theelepels per kopje. Giet er heet (niet kokend) water van ongeveer 80°C overheen en laat 5-10 minuten trekken." } },
    { "@type": "Question", name: "Wanneer merk ik de effecten en hoe lang duren ze?", acceptedAnswer: { "@type": "Answer", text: "De kalmerende effecten beginnen meestal binnen 15-30 minuten na consumptie en kunnen 2-4 uur aanhouden." } },
    { "@type": "Question", name: "Hoe wordt Lunssence verzonden en wat zijn de kosten?", acceptedAnswer: { "@type": "Answer", text: "Discreet via PostNL. Gratis verzending vanaf €50. Levertijd 1-2 werkdagen in Nederland." } },
    { "@type": "Question", name: "Hoe bewaar ik mijn Lunssence thee het beste?", acceptedAnswer: { "@type": "Answer", text: "Bewaar de thee op een koele, droge plaats in de originele verpakking. Houdbaar tot 2 jaar." } },
  ],
};

const Index = () => {
  useScrollAnimation();


  return (
    <div className="overflow-x-hidden">
      <Seo
        title="Blauwe Lotus Thee Kopen | Lunssence — Premium Blue Lotus"
        description="Premium blauwe lotus thee (Nymphaea caerulea) voor ontspanning, betere dromen en bewuste wellness-rituelen. 100% natuurlijk, legaal in NL. Gratis verzending vanaf €50."
        path="/"
        jsonLd={faqJsonLd}
      />

      <Navbar />
      <ErrorBoundary section="Hero">
        <Hero />
      </ErrorBoundary>
      <Mission />
      <Audience />
      <ErrorBoundary section="Products">
        <Products />
      </ErrorBoundary>
      <ErrorBoundary section="Blends">
        <Blends />
      </ErrorBoundary>
      <Ritual />
      <Reviews />
      <Social />
      <FAQ />
      <Newsletter />
      <Footer />
      <StickyCartButton />
      <CartDrawer />
    </div>
  );
};

export default Index;